import React from "react";
import { Row, Col } from "../../components/Component";
import { baseURLs } from '../../utils/Constants';
import packageJson from '../../../package.json';

const AuthFooter = () => {
  return (
    <div className="nk-footer nk-auth-footer-full">
      <div className="container wide-lg">
        <Row className="g-3">
          <Col lg={6} className="order-lg-last">
            <ul className="nav nav-sm justify-content-center justify-content-lg-end">
              <li className="nav-item">
                <a className="nav-link" target="_blank" rel="noreferrer" href={`${baseURLs.KUS_URL}/release-notes`}> Version: {packageJson.version}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" target="_blank" rel="noreferrer" href={`${baseURLs.KUS_URL}/terms-and-conditions`}> Terms and Conditions</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" target="_blank" rel="noreferrer" href={`${baseURLs.KUS_URL}/privacy-policy`}> Privacy Policy</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" target="_blank" rel="noreferrer" href={`https://docs.keepup.store`}> Tutorials</a>
              </li>
            </ul>
          </Col>
          <Col lg="6">
            <div className="nk-block-content text-center text-lg-start">
              <p className="text-soft">&copy; {new Date().getFullYear()} Keepup Store. All Rights Reserved.</p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default AuthFooter;
